module.exports = __webpack_public_path__ + "static/media/Unicorn Guy.053ba9b4.jpg";